import { render, staticRenderFns } from "./VTasksList.vue?vue&type=template&id=f5193aaa&scoped=true&lang=pug"
import script from "./VTasksList.vue?vue&type=script&lang=ts"
export * from "./VTasksList.vue?vue&type=script&lang=ts"
import style0 from "./VTasksList.vue?vue&type=style&index=0&id=f5193aaa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5193aaa",
  null
  
)

export default component.exports